import { IAppState } from '../common/state';
import { IAbUseExperiment } from '../types/abUseExperiments';

export const selectExperiments = (state: IAppState): IAbUseExperiment[] => state.abUseExperiments;
